import ACTION from '@constants/selectedAddress'
import { Address } from '@interfaces/address'
import { createStandardAction } from 'typesafe-actions'

export const updateSelectedAddress = createStandardAction(ACTION.UPDATE_SELECTED_ADDRESS)<number>()
